import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles({
	container: {
		background: colors.gray[0],
		border: `1px solid ${colors.gray[200]}`,
		borderRadius: "8px",
		padding: "12px 16px",
		minWidth: "160px",
		boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
	},
	label: {
		marginBottom: "8px",
		color: colors.gray[800]
	},
	entryText: {
		color: colors.gray[700]
	},
	purpleDot: {
		width: 10,
		height: 10,
		borderRadius: "50%",
		background: colors.purple[500],
		flexShrink: 0
	},
	grayDot: {
		width: 10,
		height: 10,
		borderRadius: "50%",
		background: colors.gray[400],
		flexShrink: 0
	}
})

export default useStyles
